export type SonderfallSchritt = 'angaben' | 'gesamtfoto' | 'ebenen'

const SCHRITTE: { schluessel: SonderfallSchritt; text: string }[] = [
  { schluessel: 'angaben', text: 'Angaben' },
  { schluessel: 'gesamtfoto', text: 'Gesamtfoto' },
  { schluessel: 'ebenen', text: 'Ebenen' },
]

/**
 * P7-02 legt die Reihenfolge fest: erst das Gesamtfoto der Situation, dann die Ebenen der Reihe nach.
 * Die Leiste macht sie auf jedem Schritt sichtbar, damit niemand die Ebenen vor dem Gesamtfoto
 * fotografiert.
 */
export default function SonderfallSchritte({ aktuell }: { aktuell: SonderfallSchritt }) {
  const position = SCHRITTE.findIndex((schritt) => schritt.schluessel === aktuell)
  return (
    <ol className="schrittfolge" aria-label="Ablauf Sonderfall">
      {SCHRITTE.map((schritt, index) => (
        <li
          key={schritt.schluessel}
          aria-current={index === position ? 'step' : undefined}
          className={index < position ? 'erledigt' : undefined}
        >
          <span className="nr">{index + 1}</span>
          {schritt.text}
        </li>
      ))}
    </ol>
  )
}

/** Orientierung fuer den Anwender vor dem Regal: welche Ebene gerade dran ist. */
export function ebenenLage(ebeneNr: number, anzahl: number): string {
  if (anzahl <= 1) return 'einzige Ebene'
  if (ebeneNr === 1) return 'oberste'
  if (ebeneNr === anzahl) return 'unterste'
  return `${ebeneNr}. von oben`
}
